import request from './request'

const AUTH_BASE = '/auth'
const SERVICE_TAG = '[auth.service]'

export default {
  generateExternalToken (credentials) {
    console.info(`${SERVICE_TAG} solicitando generate-external-token`, {
      uf: credentials?.uf,
      crm: credentials?.crm
    })

    return request({
      url: `${AUTH_BASE}/generate-external-token`,
      method: 'post',
      data: credentials
    })
  },

  autoLoginWithToken (token) {
    const tokenPreview = token ? `${token.substring(0, 10)}...` : 'token ausente'
    console.info(`${SERVICE_TAG} solicitando auto-login`, tokenPreview)

    return request({
      url: `${AUTH_BASE}/auto-login`,
      method: 'get',
      params: { token }
    })
  }
}
